// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyA1LpZp4HJz5OmJ2n9DWb9oz0Vk0txPtT4",
    authDomain: "inventorystream-71c10.firebaseapp.com",
    projectId: "inventorystream-71c10",
    storageBucket: "inventorystream-71c10.firebasestorage.app",
    messagingSenderId: "357768369709",
    appId: "1:357768369709:web:eb9403cc01623ce0810aa4",
    measurementId: "G-DCNJ3J07QL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };